/**
 * Contract Manager API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import {HttpClient, HttpEvent, HttpHeaders, HttpResponse} from '@angular/common/http';

import {Observable} from 'rxjs';

import {BwGraphUserConfigs} from '../model/bwGraphUserConfigs';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class BwGraphUserConfigsService {

  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  protected basePath = 'https://localhost';

  constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * operation not implemented
   *
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getBwGraphUserConfigsCollection(observe?: 'body', reportProgress?: boolean): Observable<Array<BwGraphUserConfigs>>;

  public getBwGraphUserConfigsCollection(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<BwGraphUserConfigs>>>;

  public getBwGraphUserConfigsCollection(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<BwGraphUserConfigs>>>;

  public getBwGraphUserConfigsCollection(observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/ld+json',
      'application/hal+json',
      'application/json',
      'text/html'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [];

    return this.httpClient.get<Array<BwGraphUserConfigs>>(`${this.basePath}/api/bw_graph_user_configs`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * operation not implemented
   *
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getBwGraphUserConfigsItem(id: string, observe?: 'body', reportProgress?: boolean): Observable<BwGraphUserConfigs>;

  public getBwGraphUserConfigsItem(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BwGraphUserConfigs>>;

  public getBwGraphUserConfigsItem(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BwGraphUserConfigs>>;

  public getBwGraphUserConfigsItem(id: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getBwGraphUserConfigsItem.');
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/ld+json',
      'application/hal+json',
      'application/json',
      'text/html'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [];

    return this.httpClient.get<BwGraphUserConfigs>(`${this.basePath}/api/bw_graph_user_configs/${encodeURIComponent(String(id))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Create user config
   *
   * @param bwGraphUserConfigs The new BwGraphUserConfigs resource
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public postBwGraphUserConfigsCollection(bwGraphUserConfigs?: BwGraphUserConfigs, observe?: 'body', reportProgress?: boolean): Observable<BwGraphUserConfigs>;

  public postBwGraphUserConfigsCollection(bwGraphUserConfigs?: BwGraphUserConfigs, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BwGraphUserConfigs>>;

  public postBwGraphUserConfigsCollection(bwGraphUserConfigs?: BwGraphUserConfigs, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BwGraphUserConfigs>>;

  public postBwGraphUserConfigsCollection(bwGraphUserConfigs?: BwGraphUserConfigs, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/ld+json',
      'application/hal+json',
      'application/json',
      'text/html'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
      'application/ld+json',
      'application/hal+json',
      'application/json',
      'text/html'
    ];
    let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.post<BwGraphUserConfigs>(`${this.basePath}/api/bw_graph_user_configs`,
      bwGraphUserConfigs,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update user config
   *
   * @param id
   * @param bwGraphUserConfigs The updated BwGraphUserConfigs resource
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public putBwGraphUserConfigsItem(id: string, bwGraphUserConfigs?: BwGraphUserConfigs, observe?: 'body', reportProgress?: boolean): Observable<BwGraphUserConfigs>;

  public putBwGraphUserConfigsItem(id: string, bwGraphUserConfigs?: BwGraphUserConfigs, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BwGraphUserConfigs>>;

  public putBwGraphUserConfigsItem(id: string, bwGraphUserConfigs?: BwGraphUserConfigs, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BwGraphUserConfigs>>;

  public putBwGraphUserConfigsItem(id: string, bwGraphUserConfigs?: BwGraphUserConfigs, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling putBwGraphUserConfigsItem.');
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/ld+json',
      'application/hal+json',
      'application/json',
      'text/html'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
      'application/ld+json',
      'application/hal+json',
      'application/json',
      'text/html'
    ];
    let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.put<BwGraphUserConfigs>(`${this.basePath}/api/bw_graph_user_configs/${encodeURIComponent(String(id))}`,
      bwGraphUserConfigs,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (let consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

}
